import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { StarIcon, FlameIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { IMAGES } from '../data/landing';
const OFFER_DURATION_SECONDS = 15 * 60;
export function Hero() {
  const [secondsLeft, setSecondsLeft] = useState(OFFER_DURATION_SECONDS);
  useEffect(() => {
    const timer = window.setInterval(() => {
      setSecondsLeft(current => Math.max(current - 1, 0));
    }, 1000);
    return () => window.clearInterval(timer);
  }, []);
  const minutes = Math.floor(secondsLeft / 60).toString().padStart(2, '0');
  const seconds = (secondsLeft % 60).toString().padStart(2, '0');
  return <section className="relative w-full overflow-hidden bg-neutral-950 pt-9 text-white sm:pt-10" data-id="element-96" data-mp="ncgiiawhchrm">
      {/* Barra de urgencia fija durante todo el recorrido */}
      <div className="fixed inset-x-0 top-0 z-[60] flex min-h-9 items-center justify-center bg-red-600 px-3 py-1.5 text-center text-[10px] font-bold uppercase tracking-wide text-white shadow-md sm:min-h-10 sm:text-sm" data-id="element-97" data-mp="3czfkfwx3o34z">
        <span className="flex flex-wrap items-center justify-center gap-x-2 gap-y-0.5" data-id="element-98" data-mp="3o7lrboupx2nw">
          <span data-id="element-99" data-mp="3o59efq3thihp">🔥 Oferta finaliza en</span>
          <span aria-live="polite" className="rounded bg-neutral-950 px-2 py-0.5 font-black tabular-nums text-yellow-300" data-id="element-100" data-mp="39b4l1c1dye87">
            {minutes}:{seconds}
          </span>
          <span data-id="element-101" data-mp="30iaziwvciilw">· 63% OFF</span>
        </span>
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 14
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.55
    }} className="mx-auto max-w-4xl px-4 pb-2 pt-8 text-center sm:px-6 sm:pt-12" data-id="element-102" data-mp="30gq4z7916zo1">
        <h1 className="text-3xl font-black leading-[1.05] tracking-tight sm:text-4xl lg:text-5xl" data-id="element-103" data-mp="2qi0nvgoylj8u">
          Cómo comer como en un <span className="text-yellow-400" data-id="element-104" data-mp="2hinaicxpsaiu">bodegón todos los días</span>, gastando <span className="text-yellow-400" data-id="element-105" data-mp="2hljae6t4h99x">la mitad en el súper</span> y sin lavar una sola olla.
        </h1>
      </motion.div>

      <div className="mx-auto grid max-w-6xl gap-10 px-4 py-8 sm:px-6 lg:grid-cols-2 lg:items-center lg:py-12" data-id="element-106" data-mp="s2jp22e1eam5">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="order-2 lg:order-1" data-id="element-107" data-mp="naa12rwhfkmi">
          <div className="mb-4 flex items-center gap-2" data-id="element-108" data-mp="de6n8os9pxjq">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-yellow-400 px-3 py-1 text-xs font-black uppercase text-neutral-900" data-id="element-109" data-mp="1b0vv3f9nj4di">
              <FlameIcon className="h-3.5 w-3.5" data-id="element-110" data-mp="16344qponnqbf" /> Air Fryer Argentina
            </span>
            <div className="flex items-center gap-1 text-yellow-400" data-id="element-111" data-mp="111om149y9vw7">
              {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-current" data-id="element-112" data-mp="x37cyf6yybc5" data-mpi={i} />)}
              <span className="ml-1 text-xs text-neutral-300" data-id="element-113" data-mp="3ltqeji9dp5w5">+12.400 familias</span>
            </div>
          </div>

          <p className="mt-5 text-base text-neutral-300 sm:text-lg" data-id="element-114" data-mp="3hq248rtd3w77">
            El MegaPack definitivo de{' '}
            <span className="font-bold text-white" data-id="element-115" data-mp="1x785vq9lpvv6">250 recetas</span> diseñado para el
            bolsillo y la realidad argentina. Dominá tu Air Fryer de una vez por todas.
          </p>

          <div className="mt-8" data-id="element-116" data-mp="268og9y0f1xze">
            <CtaButton data-id="element-117" data-mp="2b0fvjce4gha8" />
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.94
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="order-1 lg:order-2" data-id="element-118" data-mp="2b20pp0wixy7k">
          <img src={IMAGES.mockupPrincipal} alt="MegaPack Air Fryer Argentina: 4 tomos de recetas y 5 bonos" className="mx-auto w-full max-w-lg drop-shadow-2xl" data-id="element-119" data-mp="2p0h5dhcd6z1u" />
        </motion.div>
      </div>

      {/* Imagen realista de comida (gancho -> deseo) */}
      <div className="relative w-full" data-id="element-120" data-mp="uo0shxp2cmo0">
        <img src={IMAGES.heroFood} alt="Plato abundante estilo bodegón argentino cocinado en Air Fryer" className="h-56 w-full object-cover sm:h-80 lg:h-96" data-id="element-121" data-mp="zlkke0eooxyf" />
        <div className="absolute inset-0 flex items-end bg-gradient-to-t from-neutral-950 via-neutral-950/30 to-transparent" data-id="element-122" data-mp="49t4lwvct2tx">
          <p className="mx-auto max-w-3xl px-4 pb-6 text-center text-lg font-bold text-white sm:text-2xl" data-id="element-123" data-mp="3vk1jbz46a2xr">
            Milanesas crocantes, pollo dorado y empanadas de bodegón… sin freidora de
            aceite y sin ensuciar la cocina.
          </p>
        </div>
      </div>
    </section>;
}